// extracted by mini-css-extract-plugin
export var leftAlign = "_e-2";
export var popper = "_e-0";
export var subtitle = "_e-1";